type TTime = {
  /** 开始计时的时间戳 */
  startTime: number;
  /** 页面不可见的总时长 */
  pageInvisibleDuration: number;
};

/**
 * 计时器
 * - 用于App退到后台，页面不可见时，统计时间不正确的校正
 */
export class Timer {
  private static instance: Timer;
  public static getInstance(): Timer {
    if (!Timer.instance) {
      Timer.instance = new Timer();
    }

    return Timer.instance;
  }

  /** key: timerId, value: TTime */
  private timeMap = new Map<string, TTime>();
  private pageInvisibleStartTime: number | null = null;

  public pageVisibilityHook = (isVisible: boolean) => {
    if (!isVisible) {
      this.pageInvisibleStartTime = Date.now();
      return;
    }

    if (this.pageInvisibleStartTime) {
      const duration = Date.now() - this.pageInvisibleStartTime;
      for (const timerId of this.timeMap.keys()) {
        const time = this.timeMap.get(timerId);
        if (time) {
          const { startTime, pageInvisibleDuration } = time;
          this.timeMap.set(timerId, {
            startTime,
            pageInvisibleDuration: pageInvisibleDuration + duration,
          });
        }
      }
      this.pageInvisibleStartTime = null;
    }
  };

  /**
   * 开始计时
   * @param timerId
   */
  public start(timerId: string) {
    this.timeMap.set(timerId, {
      startTime: Date.now(),
      pageInvisibleDuration: 0,
    });
  }

  /**
   * 结束计时
   * @param timerId
   * @returns 持续时间和页面不可见的总时长
   */
  public stop(timerId: string) {
    const time = this.timeMap.get(timerId);
    if (!time) {
      return {
        duration: 0,
        pageInvisibleOffsetTime: 0,
      };
    }

    const { startTime, pageInvisibleDuration } = time;
    const duration = Math.max(Date.now() - startTime - pageInvisibleDuration, 0);
    this.timeMap.delete(timerId);
    return {
      duration,
      pageInvisibleDuration,
    };
  }
}
